import qs from 'query-string'
import {getAccessToken, getTenant} from "./jetms-interop";
import {POOL_STATUS_ALL} from '../constants/poolStatuses'

const get = (url) => {
  return fetch(url, {
    headers: {
      'Authorization': 'Bearer ' + getAccessToken(),
      'Content-Type': 'application/json',
      'x-je-tenant': getTenant(),
    },
  })
}

const put = (url, data, extraHeaders = {}) => {
  return fetch(url, {
    headers: {
      'Authorization': 'Bearer ' + getAccessToken(),
      'Content-Type': 'application/json',
      'x-je-tenant': getTenant(),
      ...extraHeaders,
    },
    body: JSON.stringify(data),
    method: 'PUT',
  })
}

const post = (url, data) => {
  return fetch(url, {
    headers: {
      'Authorization': 'Bearer ' + getAccessToken(),
      'Content-Type': 'application/json',
      'x-je-tenant': getTenant(),
    },
    body: JSON.stringify(data),
    method: 'POST',
  })
}

const patch = (url, data) => {
  return fetch(url, {
    headers: {
      'Authorization': 'Bearer ' + getAccessToken(),
      'Content-Type': 'application/json',
      'x-je-tenant': getTenant(),
    },
    body: JSON.stringify(data),
    method: 'PATCH',
  })
}

const del = (url) => {
  return fetch(url, {
    headers: {
      'Authorization': 'Bearer ' + getAccessToken(),
      'Content-Type': 'application/json',
      'x-je-tenant': getTenant(),
    },
    method: 'DELETE'
  })
}

const Summary = (params) => {
  let request = MapToPoolSummaryInternalRequest(params)
  return get(window.env.api + '/applications/deliveryconfiguration/delivery/pools/summary?' + qs.stringify(request))
}

const MapToPoolSummaryInternalRequest = params => {
  return {
    Tenant: params.Tenant,
    IsDescendingSort: (params.sortDirection === 'desc'),
    Status: params.status === POOL_STATUS_ALL ? null : params.status,
    Limit: params.itemsPerPage,
    Offset: params.offset,
    PartnerSubscriptionName: params.partner,
    PoolName: params.pool,
    Restaurant: params.restaurant,
    SortField: params.sortField
  }
}

const GetById = (id) => {
  return get(window.env.api + '/applications/deliveryconfiguration/delivery/pools/' + id)
}

const GetAll = () => {
  return get(window.env.api + '/applications/deliveryconfiguration/delivery/pools')
}

const AddPool = (pool) => {
  return post(window.env.api + '/applications/deliveryconfiguration/delivery/pools', pool)
}

const DeletePool = (id) => {
  return del(window.env.api + '/applications/deliveryconfiguration/delivery/pools/' + id)
}

const SyncPartnerRestaurantsDetails = (partnerId, partnerSubscriptionId) => {
  return put(`${window.env.api}/applications/deliveryconfiguration/sync/restaurant-details`, {}, {
    'X-JE-PartnerId': partnerId,
    'X-JE-PartnerSubscriptionId': partnerSubscriptionId
  })
}

const ManuallyOfflinePool = (poolId) => {
  return put(`${window.env.api}/applications/deliveryconfiguration/delivery/pools/${poolId}/offline`, {})
}

const ManuallyOnlinePool = (poolId) => {
  return del(`${window.env.api}/applications/deliveryconfiguration/delivery/pools/${poolId}/offline`)
}

const GetShifts = (id, offset) => {
  return get(window.env.api + '/applications/deliveryconfiguration/delivery/pools/' + id + '/shifts?offset=' + offset + '&limit=50')
}

const SaveShifts = (poolId, shifts) => {
  let putShiftsRequest = {shifts}
  return put(window.env.api + '/applications/deliveryconfiguration/delivery/pools/' + poolId + '/shifts', putShiftsRequest)
}

const SaveRestaurants = (poolId, restaurants) => {
  return put(window.env.api + '/applications/deliveryconfiguration/delivery/pools/' + poolId + '/restaurants', restaurants)
}

const GetLogs = (id, offset, limit, eventType, occurredStartDate, occurredEndDate) => {
  const requestPath = `/applications/deliveryconfiguration/delivery/pools/${id}/logs?offset=${offset}&limit=${limit}&eventType=${eventType || ''}&occurredStartDate=${occurredStartDate || ''}&occurredEndDate=${occurredEndDate || ''}`
  return get(window.env.api + requestPath)
}

const GetRestaurants = (id) => {
  return get(window.env.api + '/applications/deliveryconfiguration/delivery/pools/' + id + '/restaurants')
}

const GetDeliveryHours = (id) => {
  return get(window.env.api + '/applications/deliveryconfiguration/delivery/pools/' + id + '/hours')
}

const SaveDeliveryHours = (poolId, deliveryHours) => {
  return put(window.env.api + '/applications/deliveryconfiguration/delivery/pools/' + poolId + '/hours', deliveryHours)
}

const PoolSummary = (poolId) => {
  return get(window.env.api + '/applications/deliveryconfiguration/delivery/pools/' + poolId + '/summary')
}

const UpdateBestGuess = (poolId, bestGuessObject, partnerId, partnerSubscriptionId) => {
  return put(window.env.api + '/applications/deliveryconfiguration/delivery/pools/' + poolId + '/availability', bestGuessObject, {
    'X-JE-PartnerId': partnerId,
    'X-JE-PartnerSubscriptionId': partnerSubscriptionId
  })
}

const GetThresholds = (poolId) => {
  return get(window.env.api + '/applications/deliveryconfiguration/delivery/pools/' + poolId + '/thresholds')
}

const UpdateThresholds = (poolId, ThresholdObject) => {
  return put(window.env.api + '/applications/deliveryconfiguration/delivery/pools/' + poolId + '/thresholds', ThresholdObject)
}

const DeleteThresholds = (poolId, partnerId, partnerSubscriptionId) => {
  return del(window.env.api + '/applications/deliveryconfiguration/delivery/pools/' + poolId + '/thresholds')
}

const EditPool = (pool) => {
  return patch(window.env.api + '/applications/deliveryconfiguration/delivery/pools/' + pool.id, pool)
}

const GetPoolZoneSuggestions = (poolZone) => {
  const tenant = getTenant()
  const limit = 5
  return get(window.env.api + `/applications/deliveryconfiguration/delivery/poolzones?poolZone=${encodeURI(poolZone)}&tenant=${tenant}&limit=${limit}`)
}

export default {
  Summary,
  GetById,
  GetAll,
  GetLogs,
  GetRestaurants,
  GetShifts,
  SaveShifts,
  SaveRestaurants,
  AddPool,
  DeletePool,
  GetDeliveryHours,
  SaveDeliveryHours,
  PoolSummary,
  UpdateBestGuess,
  EditPool,
  GetPoolZoneSuggestions,
  SyncPartnerRestaurantsDetails,
  ManuallyOfflinePool,
  ManuallyOnlinePool,
  GetThresholds,
  UpdateThresholds,
  DeleteThresholds
}




// WEBPACK FOOTER //
// ./src/api/pools.js